import React from 'react';
import { Link } from 'react-router-dom';

export default function InputDialog({titler,message,showDialog,underover,setShowDialog}) {
	console.log(showDialog);
  const closeDialog = () => {
    setShowDialog(false);
  };
  return (
        <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0, 0, 0, 0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <div style={{ backgroundColor: '#fff', padding: '20px', borderRadius: '8px', textAlign: 'center', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)' }}>
            <h3>{titler}</h3>
            <p>{message}</p>
            <form>
          <select
            name="category"
            style={{ width: '90%', padding: '8px', border: '1px solid black', borderRadius: '4px', color: 'black', margin: '1em' }}
          >
            <option value={underover}>Select...</option>
            <option value="Under">Under</option>
            <option value="Over">Over</option>
          </select>
          <input
            type="text"
            name="units"
            placeholder='10'
            style={{ width: '50%', padding: '8px', border: '1px solid black', borderRadius: '4px', color: 'black', margin: '1em' }}
          />
          <button style={{ padding: '5px 5px', border: 'none', backgroundColor: '#007BFF', color: '#fff', borderRadius: '4px', cursor: 'pointer' }}>
            Submit
          </button>
            </form>
            <button onClick={closeDialog} style={{ padding: '10px 20px', border: 'none', backgroundColor: '#007BFF', color: '#fff', borderRadius: '4px', cursor: 'pointer' }}>
              Close
            </button>
          </div>
        </div>
  );
}

